import { debug } from './debug';

export const makePostRequest = async <T>(
  url: string,
  body: string,
  apiKey: string,
  loadId: string
): Promise<T | null> => {
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Edkt-Load-Id': loadId,
        'X-Edkt-Api-Key': apiKey,
      },
      body,
    });
    if (response.status !== 200) {
      return null;
    }
    return await response.json();
  } catch (err) {
    debug('Error:', err);
    return null;
  }
};

export const makeGetRequest = async <T>(
  url: string,
  apiKey: string,
  loadId: string
): Promise<T | null> => {
  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Headers': '*',
        'X-EDKT-Load-Id': loadId,
        'X-EDKT-API-KEY': apiKey,
      },
    });
    const res = await response.json();
    return res;
  } catch (err) {
    debug('Error:', err);
    return null;
  }
};
